export default "/_next/static/js/scripts-f1f0c183d1680eb9833e3803c1aff091.js";